/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import { SpinStates } from '../States/SpinStates';
import QuickStopComponent from './QuickStopComponent';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/**
 * [[QuickStopComponent]] child class for executing instantanious quick stops.
 * ie quicker quick stops.
 */
@cc._decorator.ccclass
export default class InstantQuickStopComponent extends QuickStopComponent
{
    @property(cc.Float)
    protected indexedDelayMS: number = 50;

    /** @hidden */
    protected quickStopHandler(): void
    {
        if (this.reels[this.reels.length - 1].SpinState !== SpinStates.Stopping)
        {
            if (!this.reelManager.IsAllStopped()) { return; }
        }
        else
        {
            let reelIndex: number = 0;
            this.reels.forEach(reel =>
                {
                    if (reel.IsStopped) { return; }

                    reel.InstantQuickStop(reelIndex++ * this.indexedDelayMS);
                });
        }

        this.shouldQuickStop = false;
        this.hasExecuted = true;
    }
}
